import { TextField } from '@mui/material';
import { useController } from 'react-hook-form';
import NumberFormat from 'react-number-format';

type PhoneTextFieldProps = {
  name: `${string}` | `${string}.${string}` | `${string}.${number}`;
  label: string;
  rules?: Object;
  error?: boolean;
  helperText?: string;
  readOnly?: boolean;
  defaultValue?: string | number;
  fullWidth?: boolean;
};
//TODO validate complete phone number
export function PhoneTextField({
  name,
  label,
  rules,
  error,
  helperText,
  readOnly,
  defaultValue,
  fullWidth = true,
}: PhoneTextFieldProps) {
  const {
    field: { ref, onChange, value },
  } = useController({
    name,
    rules,
    defaultValue,
  });
  return (
    <NumberFormat
      id={name}
      type='tel'
      format='(###) ###-####'
      mask='_'
      thousandSeparator={true}
      customInput={TextField}
      onValueChange={v => {
        const value = v.formattedValue;
        onChange(value);
      }}
      value={value}
      fullWidth={fullWidth}
      decimalScale={2}
      label={label}
      error={error}
      helperText={helperText}
      variant='outlined'
      InputProps={{
        readOnly,
      }}
      getInputRef={ref}
    />
  );
}
